var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.924 25.3723C26.0892 25.2045 26.1811 24.978 26.1797 24.7424C26.1782 24.5068 26.0835 24.2815 25.9164 24.1157L18.6181 16.8948C19.8058 15.2731 20.3289 13.2576 20.0801 11.2619C19.8313 9.26611 18.8293 7.44137 17.2799 6.16194C15.7304 4.88252 13.7508 4.2454 11.7472 4.38129C9.74358 4.51717 7.86784 5.41575 6.50472 6.8927C5.14161 8.36965 4.39445 10.313 4.41653 12.3241C4.4386 14.3353 5.22822 16.2617 6.62343 17.7083C8.01863 19.1549 9.91364 20.012 11.9197 20.1037C13.9258 20.1954 15.891 19.5149 17.412 18.2017L24.6683 25.3799C24.8358 25.5453 25.0619 25.6374 25.2972 25.636C25.5324 25.6346 25.7574 25.5397 25.9229 25.3723H25.924ZM18.3617 12.2499C18.3618 13.4529 18.0057 14.629 17.3384 15.6293C16.6712 16.6296 15.7227 17.4093 14.613 17.8697C13.5032 18.3301 12.2821 18.4506 11.104 18.2159C9.92586 17.9813 8.84369 17.402 7.99432 16.5513C7.14496 15.7007 6.56654 14.6168 6.33223 13.4369C6.09791 12.257 6.21823 11.034 6.67795 9.9226C7.13768 8.81118 7.91616 7.86126 8.91496 7.19296C9.91375 6.52467 11.088 6.16803 12.2892 6.16814C13.8991 6.17002 15.4426 6.81138 16.581 7.95152C17.7194 9.09167 18.3598 10.6375 18.3617 12.2499Z",
    fill: "#03283A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconBlack);
export default __webpack_public_path__ + "static/media/search-icon-black.6d9ad714618b9f0ae1108f0660381d9a.svg";
export { ForwardRef as ReactComponent };